<template>
  <div class="embedded">
    <transition name="fade" mode="out-in">
      <router-view id="embeddedRouter"></router-view>
    </transition>
  </div>
</template>
  
<script>
export default {
  name: "embedded",
  created() {
    if (this.$route.query && this.$route.query.tabId) sessionStorage.setItem("AA_TAB_ID", this.$route.query.tabId);
  }
};
</script>
  
<style lang="scss" scoped>
.embedded {
  height: 100vh;

  #embeddedRouter {
    height: 100vh;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/views/Embedded/Embedded.vue